import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    clusterContainer: {
        height: "100%",
        width: "100%",
        overflow: "hidden",
    },
    gridContainer: {
        padding: `${theme.spacing(4)} ${theme.spacing(8)}`,
        height: "100%",
        justifyContent: "flex-start",
        gap: theme.spacing(3),
    },
}));
